import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, map, takeUntil } from 'rxjs';
import { UserService } from '@wm-libs/core';
import { ActiveSessionsService } from '../../../../core/services/active-sessions.service';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveSessionsComponent } from '../../components/active-sessions/active-sessions.component';
import { ToggleTfaComponent } from '../../components/toggle-tfa/toggle-tfa.component';
import { ChangePasswordComponent } from '../../components/change-password/change-password.component';
import { ProfileInfoComponent } from '../../components/profile-info/profile-info.component';
import { NgClass, NgIf, AsyncPipe } from '@angular/common';
import { User } from '@wm-libs/core';
import { Session } from '../../../../core/interfaces/sessions.interface';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, ProfileInfoComponent, ChangePasswordComponent, ToggleTfaComponent, ActiveSessionsComponent, AsyncPipe, TranslateModule],
})
export class ProfileComponent implements OnInit, OnDestroy {
  userData$!: User | null;
  activeSessions: Session[] | null = null;
  activeSessionsLoaded = false;

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((result) => result.matches));
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches));
  isMedium$ = this.breakpointObserver.observe([Breakpoints.Medium]).pipe(map((result) => result.matches));

  private _unsubscribe$: Subject<void> = new Subject<void>();
  constructor(private breakpointObserver: BreakpointObserver, private userService: UserService, private activeSessionsService: ActiveSessionsService) {
    this.userService.userData$.pipe(takeUntil(this._unsubscribe$)).subscribe((status) => {
      this.userData$ = status;
    });
  }

  ngOnInit(): void {
    this.getActiveSessions();
  }

  getActiveSessions() {
    this.activeSessionsService.getActiveSessions().subscribe((res) => {
      this.activeSessions = res;
      this.activeSessionsLoaded = true;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
